import React from 'react'
import Flickity from 'flickity'
import { TextTemplateStyle } from './../../../../../styles'

export default ({title, description, description2, isBrand, subtitle, category}) => (
    <div className={`product-template--base ${TextTemplateStyle}`}>
      <div className="template-scroll">
        <div className="template-content">
            { category && isBrand && (<span className="title-brand">{category}</span>) }
            { title && !isBrand  && (<h2 className='subtitle'>{ title }</h2> )}
            { isBrand && subtitle  && (<h2 className={`subtitle subtitle--brand `}>{ subtitle }</h2> )}
            { title && isBrand &&  (<h3 className="subtitle-h3"> {title} </h3>)}

          <div className="flex">
            <div className="template-left">
              { description && ( <div className="content" dangerouslySetInnerHTML={{__html: description}} /> )}
            </div>
            <div className="template-right ">
              { description2 && ( <div className="content" dangerouslySetInnerHTML={{__html: description2}} /> )}
            </div>
          </div>
        </div>
      </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Product/ProductTemplates/FullTextTemplate.js